import { createLogger } from "@xmiles/web-log";

export const logger = createLogger({
  projectId: 'Holopix',
  userId: '',
  debug: true,
  autoReport: false,
  reportInterval: 1000 * 60 * 1,
});
